import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBalanceScale, faHandshake, faMapMarkerAlt, faLaptop, faUserShield, faBolt } from '@fortawesome/free-solid-svg-icons';

// Homepage "Why Choose GM Insurance Services?" section (STATIC, code-managed).
const REASONS = [
    { icon: faBalanceScale, title: "Compare Multiple Insurance Options", text: "We help customers compare quotes and coverage options from multiple insurance carriers." },
    { icon: faHandshake, title: "Personal and Business Insurance Help", text: "Our team can help with auto, homeowners, commercial auto, trucking, business insurance, general liability, workers compensation, and earthquake insurance." },
    { icon: faMapMarkerAlt, title: "California Insurance Experience", text: "GM Insurance Services understands the insurance needs of California drivers, homeowners, and business owners." },
    { icon: faLaptop, title: "Local Service, Online Convenience", text: "Start your quote online or call our team for help at 877-333-8303." },
    { icon: faUserShield, title: "Coverage That Fits Your Needs", text: "We help you review your options so you can choose coverage based on your budget, risk, and insurance requirements." },
    { icon: faBolt, title: "Fast and Easy to Work With", text: "We make the insurance quote process simple, clear, and convenient so you can get help without unnecessary delays." },
];

const scrollToQuote = () => window.scrollTo({ top: 0, behavior: "smooth" });

function HomeF6() {
    return (
        <div className="why-choose">
            <style>{`
                .why-choose{width:100vw;margin-left:-15px;background:#fff;padding:56px 24px;}
                .why-choose__inner{max-width:1100px;margin:0 auto;}
                .why-choose h2{text-align:center;font-size:2em;font-weight:700;color:#132042;margin-bottom:1.4em;}
                .why-card{display:flex;flex-direction:column;align-items:center;text-align:center;height:100%;
                    background:#f8f9fb;border:1px solid #e6e9ef;border-radius:12px;padding:28px 20px;}
                .why-card svg{font-size:40px;color:#1b75bc;margin-bottom:14px;}
                .why-card h3{font-size:1.02rem;font-weight:600;color:#132042;margin:0 0 8px;}
                .why-card p{font-size:.88rem;color:#6b7a90;margin:0;line-height:1.6;}
                .why-choose__cta{text-align:center;margin-top:2.2em;}
            `}</style>
            <div className="why-choose__inner">
                <h2>Why Choose GM Insurance Services?</h2>
                <div className="row">
                    {REASONS.map(({ icon, title, text }) => (
                        <div className="col-lg-4 col-sm-6 mb-4" key={title}>
                            <div className="why-card">
                                <FontAwesomeIcon icon={icon} />
                                <h3>{title}</h3>
                                <p>{text}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="why-choose__cta">
                    <button type="button" onClick={scrollToQuote} className="btn btn-raised btn-success btn-gm-green btn-home-radius">Get a Free Quote</button>
                </div>
            </div>
        </div>
    );
}

export default HomeF6;
